import { Directive, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appDisabled]',
    standalone: true
})
export class appDisabled {
    @Input() appDisabled: boolean = false;

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (!this.appDisabled) return;

        const allowedKeys = ['Shift', 'Tab'];

        // Permitir Shift solo como modificador, no solo
        if (allowedKeys.includes(event.key)) {
            return; // ✅ Permitir Shift y Tab
        }

        // Bloquear cualquier otra tecla (como Space, Enter, etc.)
        event.preventDefault();
        event.stopPropagation();
    }

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent) {
        if (this.appDisabled) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
}